// Auto-generated cornerstone translation for pt.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:33:50.547482+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "App de gestão de cavalos: melhor escolha para 2026 | EquiSight",
      description: "Compare apps de gestão de cavalos para proprietários, estábulos e haras. Descubra por que o EquiSight é o app completo para o seu cavalo.",
      keywords: [
        "app de gestão de cavalos",
        "app de gestão de estábulo",
        "diário de cavalos app",
        "app para gerir vários cavalos",
        "app de gestação de égua",
        "app de haras cavalos",
        "melhor app de gestão de cavalos",
      ],
    },
    hero: {
      eyebrow: "Guia de escolha · software de gestão de cavalos",
      breadcrumbLabel: "App de gestão de cavalos",
      title: "App de gestão de cavalos: o guia completo para proprietários, estábulos e haras.",
      intro: "Não é uma simples lista de funcionalidades — é uma comparação honesta, um guia de escolha e um olhar sobre o que um app de gestão de cavalos realmente precisa oferecer em 2026. Para um cavalo, para um estábulo inteiro ou para o seu haras.",
      pills: [
        {
          icon: "Users",
          label: "Para proprietários",
        },
        {
          icon: "Building2",
          label: "Para estábulos",
        },
        {
          icon: "Baby",
          label: "Para haras",
        },
        {
          icon: "Share2",
          label: "Para equipas",
        },
      ],
      ctas: [
        {
          label: "Comece grátis com 1 cavalo",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabela de comparação",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por que um app de gestão de cavalos é cada vez mais importante.",
      lead: "Na prática, a gestão de cavalos é fragmentada: WhatsApp, agenda, Excel, fotos no telemóvel, passaporte em papel, faturas soltas e acordos verbais. Com um cavalo já é complicado. Com vários cavalos, haras ou cuidados partilhados surgem lacunas, compromissos esquecidos e discussões.",
      items: [
        "Onde estava aquela data de vacinação mesmo?",
        "Quem pagou o ferrador?",
        "Qual égua precisa de ser controlada hoje?",
        "O treinador leu as instruções da semana passada?",
        "Guardei mesmo esse documento com foto?",
        "O plano alimentar que está no estábulo ainda está atualizado?",
      ],
    },
    what: {
      title: "O que é um app de gestão de cavalos?",
      lead: "Um app de gestão de cavalos é essencialmente um dossiê digital por cavalo. Sem notas dispersas, mas um único lugar para saúde, treino, alimentação, documentos, planeamento, lembretes, custos, fotos, vídeos e acesso partilhado. Todos à volta do cavalo consultam a mesma informação atualizada.",
      targetGroupsTitle: "Para quem é um app de gestão de cavalos?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Proprietário particular",
          body: "Um cavalo, um dossiê — saúde, planeamento e histórico no seu bolso.",
        },
        {
          icon: "Users",
          title: "Proprietário com vários cavalos",
          body: "Perfis separados, planeamento independente, lista de tarefas partilhada para toda a equipa.",
        },
        {
          icon: "Building2",
          title: "Estábulo de pensão & picadeiro",
          body: "Acesso do proprietário, instruções de cuidados, agenda e tarefas partilhadas.",
        },
        {
          icon: "Baby",
          title: "Haras",
          body: "Ciclo da égua, gestação, dados do garanhão, pedigree e desenvolvimento do poldro.",
        },
        {
          icon: "Target",
          title: "Treinadores",
          body: "Visão por cavalo, registo de sessões, definição de objetivos, análise de vídeos.",
        },
        {
          icon: "ClipboardList",
          title: "Profissionais",
          body: "Ferrador, odontologista, fisioterapeuta ou veterinário — trabalham a partir do mesmo dossiê.",
        },
      ],
    },
    criteria: {
      title: "O que deve ter um bom app de gestão de cavalos?",
      lead: "Um app não é apenas bonito — tem de funcionar de forma prática no dia a dia. Cinco elementos que não podem faltar na escolha de 2026.",
      items: [
        {
          icon: "FileText",
          title: "Dossiê por cavalo",
          body: "Dados, idade, raça, informação do passaporte, proprietário, estábulo, fotos e documentos — tudo ligado a um único perfil de cavalo.",
        },
        {
          icon: "Heart",
          title: "Saúde e cuidados",
          body: "Vacinações, desparasitações, ferrador, odontologista, veterinário, tratamentos, medicação e lembretes automáticos antes da data de validade.",
        },
        {
          icon: "Activity",
          title: "Treino e progresso",
          body: "Registo de treinos, notas, vídeos, resultados de competições, objetivos e progresso por disciplina ou por cavalo.",
        },
        {
          icon: "Apple",
          title: "Alimentação e maneio",
          body: "Planos alimentares, suplementos, forragem, peso, condição corporal e a rotina diária que o estábulo precisa de conhecer.",
        },
        {
          icon: "Share2",
          title: "Partilha com outros",
          body: "Acesso para proprietário, tratador, treinador, responsável pelo estábulo ou profissional — com gestão de permissões adequada a cada papel.",
        },
        {
          icon: "Calendar",
          title: "Planeamento e lembretes",
          body: "Uma agenda partilhada com tarefas, lembretes automáticos e confirmações para que nada se perca.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs outros apps de gestão de cavalos.",
      lead: "O mercado conta atualmente com Stalmanager, LogMyHorse, EquineM e Happie Horse. Cada um tem os seus pontos fortes. Colocamos as funcionalidades mais pedidas lado a lado, de forma honesta e com base em informação publicamente disponível.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Início gratuito",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Vários cavalos",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dossiê de saúde",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Treino e progresso",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Alimentação e suplementos",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planeamento e lembretes",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documentos por cavalo",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Partilha com equipa e permissões",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Módulo de haras (completo)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ciclo da égua",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planeamento de gestação + ecografias",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Desenvolvimento do poldro",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integração de profissionais",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Insights EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adequado para proprietários",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Adequado para haras",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adequado para estábulo/picadeiro",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparação baseada em funcionalidades publicamente disponíveis em janeiro de 2026. Os concorrentes são também boas ferramentas; o EquiSight foi criado para combinar todos os módulos numa única app.",
    },
    why: {
      title: "Por que o EquiSight é diferente.",
      lead: "Um diário regista. O EquiSight combina gestão de cavalos, treino, alimentação, saúde, competições, profissionais e haras numa única app moderna — e vai um passo além com insights.",
      points: [
        {
          icon: "Heart",
          title: "Uma app para toda a vida do cavalo",
          body: "Do poldro ao cavalo de desporto, égua reprodutora ou cavalo de reforma. O dossiê cresce com o seu cavalo — nada se perde pelo caminho.",
        },
        {
          icon: "Sparkles",
          title: "Não apenas dados, também padrões",
          body: "O EquiCoach combina desenvolvimento, queixas recorrentes, treino e alimentação — para que detete sinais a tempo, não apenas notificações soltas.",
        },
        {
          icon: "Share2",
          title: "Criado para colaboração",
          body: "Proprietário, responsável pelo estábulo, treinador, ferrador e outros profissionais trabalham a partir do mesmo dossiê — com as permissões adequadas ao seu papel.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nicho · haras",
      title: "Gestão de cavalos para haras.",
      lead: "Muitos concorrentes mencionam haras numa única linha. O EquiSight criou um módulo de haras completo — porque o criador raramente é o utilizador final de uma app genérica, mas precisa de planeamento mais do que ninguém.",
      items: [
        "Acompanhamento diário do ciclo da égua",
        "Data de inseminação + dados do garanhão",
        "Controlo de gestação com ecografias",
        "Data prevista do parto + alertas",
        "Desenvolvimento do poldro por mês",
        "Pedigree e ascendência",
        "Notas por égua",
        "Visão geral de todas as éguas gestantes",
      ],
      ctaLabel: "Ver o módulo de haras",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nicho · estábulo & picadeiro",
      title: "Gestão de cavalos para vários cavalos e estábulos de pensão.",
      lead: "Com vários cavalos, a questão é menos sobre dados e mais sobre comunicação. Cada proprietário tem as suas preferências, rotinas, acordos de alimentação e pontos de atenção médica. Cada funcionário precisa de aceder a isso sem ter de procurar.",
      cards: [
        {
          t: "Cavalos por proprietário",
          d: "Cada proprietário vê apenas o(s) seu(s) cavalo(s).",
        },
        {
          t: "Instruções de cuidados",
          d: "Visível por cavalo para o estábulo.",
        },
        {
          t: "Agenda partilhada",
          d: "Ferrador, veterinário e competições numa única vista.",
        },
        {
          t: "Lista de tarefas",
          d: "Atribuição a funcionários, com confirmação.",
        },
        {
          t: "Acesso do proprietário",
          d: "Os clientes veem o seu cavalo na própria app.",
        },
        {
          t: "Contactos de emergência",
          d: "Sempre acessíveis em situações de stress no estábulo.",
        },
      ],
      ctaLabel: "Ver o módulo de picadeiro",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Do WhatsApp, Excel e quadro branco para o EquiSight.",
      lead: "Concretamente: é assim que a sua gestão diária de cavalos muda.",
      rows: [
        {
          before: "Grupos de WhatsApp",
          after: "Notas estruturadas por cavalo",
        },
        {
          before: "Folhas de Excel",
          after: "Dossiê digital em tempo real com histórico",
        },
        {
          before: "Quadro branco no estábulo",
          after: "Planeamento partilhado no seu telemóvel",
        },
        {
          before: "Fotos soltas na câmara",
          after: "Média associada ao seu cavalo",
        },
        {
          before: "Acordos verbais",
          after: "Tarefas e lembretes com confirmação",
        },
        {
          before: "Passaporte em papel perdido",
          after: "Documentos sempre à mão",
        },
      ],
    },
    helper: {
      title: "Qual app de gestão de cavalos é a certa para si?",
      lead: "Responda a estas 5 perguntas e receba uma recomendação honesta — mesmo que nem sempre seja o EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Tem um cavalo ou vários cavalos?",
          options: [
            {
              label: "Um cavalo",
              score: 1,
            },
            {
              label: "2–5 cavalos",
              score: 2,
            },
            {
              label: "Mais de 5 cavalos",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Gere cavalos de clientes ou terceiros?",
          options: [
            {
              label: "Não, apenas os meus próprios cavalos",
              score: 0,
            },
            {
              label: "Às vezes — para família ou conhecidos",
              score: 1,
            },
            {
              label: "Sim, profissionalmente (estábulo / picadeiro)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Quer acompanhar criação e gestação?",
          options: [
            {
              label: "Não é relevante",
              score: 0,
            },
            {
              label: "Às vezes — criação ocasional",
              score: 1,
            },
            {
              label: "Sim, sou (ou serei) criador",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Trabalha com treinador, tratador ou profissional?",
          options: [
            {
              label: "Não, faço tudo sozinho",
              score: 0,
            },
            {
              label: "Sim, com 1 pessoa",
              score: 1,
            },
            {
              label: "Sim, com várias pessoas",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Quer apenas registar ou também obter insights?",
          options: [
            {
              label: "Apenas registar",
              score: 1,
            },
            {
              label: "Registar + planeamento",
              score: 2,
            },
            {
              label: "Registar + planeamento + insights",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Um diário simples é suficiente — e cresce consigo.",
          body: "Para um cavalo sem cuidados partilhados, qualquer app de gestão de cavalos serve. O EquiSight começa gratuitamente com 1 cavalo, por isso não há risco. Se mais tarde quiser adicionar mais cavalos, um treinador ou haras, tudo já está incluído.",
          cta: "Comece grátis com 1 cavalo",
        },
        mid: {
          title: "O EquiSight adapta-se bem à sua situação.",
          body: "Tem várias necessidades (vários cavalos, colaboração ou insights). A maioria dos concorrentes cobre 1-2 módulos; o EquiSight combina-os numa única app, sem precisar de ligar ferramentas separadas.",
          cta: "Veja o que o EquiSight pode fazer",
        },
        high: {
          title: "O EquiSight é a escolha mais lógica.",
          body: "A sua situação combina vários cavalos, colaboração, haras e/ou insights. É exatamente aqui que o EquiSight faz a diferença — sem ferramentas dispersas, mas um único dossiê para tudo e todos à volta do cavalo.",
          cta: "Comece grátis com o EquiSight",
        },
      },
    },
    faqTitle: "Perguntas frequentes sobre apps de gestão de cavalos",
    faq: [
      {
        q: "Qual é a melhor app de gestão de cavalos?",
        a: "A melhor app de gestão de cavalos depende da sua situação. Para um simples diário, várias apps são adequadas. Se quiser combinar saúde, treino, alimentação, documentos, haras, planeamento e colaboração, o EquiSight foi criado como solução completa onde tudo se reúne num único dossiê.",
      },
      {
        q: "Posso gerir vários cavalos numa única app?",
        a: "Sim. Uma boa app de gestão de cavalos deve suportar vários cavalos, incluindo proprietários, tratadores, rotinas, documentos, compromissos e lembretes por cavalo. O EquiSight foi concebido para isso desde a primeira linha de código — os cavalos são dossiês individuais, não linhas numa lista.",
      },
      {
        q: "O EquiSight é adequado para haras?",
        a: "Sim. O EquiSight pode ser configurado com funcionalidades de haras como ciclo da égua, data de inseminação, controlo de gestação, dados do garanhão, pedigree, data prevista do parto e desenvolvimento do poldro. É exatamente a área onde a maioria das apps concorrentes não cobre ou cobre de forma muito limitada.",
      },
      {
        q: "Posso partilhar dados com o meu treinador ou ferrador?",
        a: "Sim. O objetivo do EquiSight é que informação relevante possa ser partilhada de forma segura com as pessoas à volta do cavalo — treinador, ferrador, odontologista, veterinário, fisioterapeuta, tratador ou proprietário. Cada pessoa recebe apenas as permissões necessárias para o seu papel.",
      },
      {
        q: "Por que não usar simplesmente o WhatsApp ou Excel?",
        a: "O WhatsApp e o Excel funcionam enquanto tudo é simples. Assim que tiver vários cavalos, compromissos, documentos, tratamentos, proprietários ou dados de haras, torna-se propenso a erros: a informação dispersa-se, pesquisar demora tempo e os acordos verbais desaparecem. Uma app de gestão de cavalos reúne tudo por cavalo, com lembretes automáticos.",
      },
      {
        q: "Quanto custa o EquiSight?",
        a: "Pode começar gratuitamente com 1 cavalo. Se quiser gerir vários cavalos, ativar haras ou dar acesso a profissionais, existem planos Premium acessíveis. Consulte as opções atuais na página de preços.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software de criação de cavalos: comparação completa 2026",
      description: "Compare software de criação de cavalos: ciclo da égua, gestação, escolha de garanhão e potros. Descubra por que o EquiSight é o app completo de criação.",
      keywords: [
        "software de criação de cavalos",
        "app ciclo da égua",
        "app gestação de égua",
        "app registro de potro",
        "app stud book cavalo",
        "planejamento de cobrição cavalo",
        "app escolha de garanhão",
      ],
    },
    hero: {
      eyebrow: "Guia de escolha · software de criação",
      breadcrumbLabel: "Software de criação",
      title: "Software de criação de cavalos: a comparação completa para 2026.",
      intro: "Uma égua reprodutora merece mais do que um app genérico de gestão equestre. Compare as funcionalidades de criação das ferramentas mais conhecidas, descubra o que realmente importa e escolha conscientemente o software que se adapta ao seu haras — grande ou pequeno.",
      pills: [
        {
          icon: "Baby",
          label: "Ciclo da égua",
        },
        {
          icon: "Heart",
          label: "Controle de gestação",
        },
        {
          icon: "Sparkles",
          label: "Desenvolvimento do potro",
        },
        {
          icon: "FileText",
          label: "Stud book",
        },
      ],
      ctas: [
        {
          label: "Comece gratuitamente com o módulo de criação",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabela de comparação",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por que um app comum de gestão equestre não é suficiente para criação.",
      lead: "A maioria dos apps equestres foi projetada para um cavalo de esporte ou lazer. A criação tem um ritmo completamente diferente: cio, inseminação, controle de gestação, ecografias, calendário de potros, pedigree e venda. Uma planilha Excel desanda após 2 temporadas — e com várias éguas, você perde o controle.",
      items: [
        "Quando foi o último ciclo da Bonita mesmo?",
        "Qual garanhão está planejado para a cobrição na próxima temporada?",
        "A ecografia de 21 dias já foi agendada?",
        "Quais potros de 2024 já foram vendidos?",
        "Onde está o diagrama de pedigree até o avô materno?",
        "Onde estão as amostras de DNA e os dados do passaporte?",
      ],
    },
    what: {
      title: "O que é software de criação de cavalos?",
      lead: "Software de criação é um dossiê especializado por égua e garanhão, combinado com um calendário de reprodução, planejamento de gestação, registro de potros e visualização de pedigree. Não é um diário equestre genérico, mas uma ferramenta que compreende o ciclo reprodutivo: do primeiro cio ao desmame.",
      targetGroupsTitle: "Para que tipo de criador o software de criação é indicado?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Criador amador (1-3 éguas)",
          body: "Uma ou duas coberturas por ano — controle sem malabarismos de planilha.",
        },
        {
          icon: "Building2",
          title: "Haras pequeno (4-10 éguas)",
          body: "Um plano reprodutivo com ciclo, inseminação, controles de gestação e dossiê do potro.",
        },
        {
          icon: "Users",
          title: "Haras profissional (10+)",
          body: "Vários funcionários, escolha de garanhão por égua, venda e marketing.",
        },
        {
          icon: "Target",
          title: "Proprietário de garanhão",
          body: "Histórico de pedidos, estatísticas de sêmen e agenda por garanhão.",
        },
        {
          icon: "Heart",
          title: "Transferência de embrião",
          body: "Doadora + receptora como dossiê vinculado, calendário de TE.",
        },
        {
          icon: "ClipboardList",
          title: "Registro no stud book",
          body: "Amostras de DNA, documentos de passaporte e dados de pedigree.",
        },
      ],
    },
    criteria: {
      title: "O que um bom software de criação deve oferecer?",
      lead: "Nem toda 'função de criação' em um app equestre é igual. Cinco áreas principais onde os criadores perdem muito tempo — e onde o software faz uma diferença real.",
      items: [
        {
          icon: "Calendar",
          title: "Ciclo da égua e cio",
          body: "Registro diário, ovulação preditiva, avanço por ciclo e lembretes automáticos.",
        },
        {
          icon: "Heart",
          title: "Inseminação e controle de gestação",
          body: "Datas de cobertura e inseminação, dados do garanhão, ecografia de 14, 21 e 60 dias e determinação do sexo.",
        },
        {
          icon: "Baby",
          title: "Desenvolvimento do potro",
          body: "Dados de nascimento, gráfico de peso, esquema de vermifugação, desmame, registro de passaporte.",
        },
        {
          icon: "FileText",
          title: "Pedigree e documentos",
          body: "Visualização de pedigree até 4-5 gerações, DNA, números de passaporte e status no stud book.",
        },
        {
          icon: "Target",
          title: "Escolha e combinação de garanhão",
          body: "Filtrar por disciplina, linhagens, dados do garanhão e histórico de sucesso — não apenas o que o proprietário do garanhão promove.",
        },
        {
          icon: "Share2",
          title: "Colaboração com veterinário/inseminador",
          body: "Ecografias, amostras e status compartilhados diretamente com a clínica que cuida das suas éguas.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs outros softwares de criação.",
      lead: "Os resultados de busca para software de criação frequentemente mostram apps equestres genéricos que mencionam criação em apenas uma frase. Comparamos honestamente quais ferramentas têm realmente um fluxo completo de criação.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Começar gratuitamente",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Registrar ciclo da égua",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Data de inseminação + garanhão",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ecografias e controle de gestação",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Data prevista de nascimento do potro",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dossiê do potro (peso/crescimento)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pedigree até 4-5 gerações",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Registro de DNA e passaporte",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Escolha/combinação de garanhão",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "TE / transferência de embrião",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Visão geral de múltiplas éguas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Compartilhar com veterinário",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrado com dossiê geral",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Venda e marketing de potros",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparação baseada em funcionalidades publicamente disponíveis em janeiro de 2026. O EquineGenie é forte em criação, mas menos em mobile e gestão equestre geral. O EquiSight combina ambos.",
    },
    why: {
      title: "Por que o EquiSight atende os criadores de forma diferente.",
      lead: "Muitos criadores usam um software de criação separado e um app de gestão equestre à parte. O EquiSight combina os dois — sem precisar alternar entre apps ou inserir dados em duplicata.",
      points: [
        {
          icon: "Heart",
          title: "A égua reprodutora continua sendo um cavalo",
          body: "A égua reprodutora tem um dossiê de criação e um dossiê equestre comum — saúde, vacinas, ferrageamento. Um único app, todos os módulos.",
        },
        {
          icon: "Sparkles",
          title: "Preditivo em vez de reativo",
          body: "Previsão de ciclo, lembretes de marcos de gestação e calendário de potros — automaticamente com base nos seus dados.",
        },
        {
          icon: "Share2",
          title: "Todos ao redor da criação",
          body: "Inseminador, proprietário de garanhão, veterinário, comprador, stud book — todos com acesso e as permissões adequadas.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Por disciplina · do ciclo ao desmame",
      title: "O que um dossiê de criação no EquiSight contém.",
      lead: "Cada égua recebe um dossiê completo de criação, vinculado ao seu dossiê equestre regular.",
      items: [
        "Registro diário do ciclo com previsão",
        "Inseminação/cobertura + dados do garanhão",
        "Linha do tempo de ecografias (14/21/60 dias + sexo)",
        "Marcos de gestação com lembretes automáticos",
        "Data prevista de nascimento e preparação",
        "Dossiê do potro desde o nascimento",
        "Pedigree até avós com navegação por clique",
        "Amostra de DNA, passaporte, status no stud book",
        "Pipeline de vendas com interessados",
        "Histórico de escolha de garanhão por égua",
      ],
      ctaLabel: "Ver o módulo de criação",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Para todo o haras",
      title: "Visão geral de múltiplas éguas e garanhões.",
      lead: "Quando você cria mais de 2-3 éguas, ter controle sobre todos os ciclos e gestações torna-se essencial.",
      cards: [
        {
          t: "Painel de ciclos",
          d: "Todas as éguas lado a lado, com a fase do ciclo e a próxima ação.",
        },
        {
          t: "Pipeline de gestação",
          d: "Quais éguas estão em qual marco da gestação?",
        },
        {
          t: "Calendário de potros",
          d: "Nascimentos esperados por mês, com a logística alinhada.",
        },
        {
          t: "Portfólio de garanhões",
          d: "Garanhões próprios ou inseminadores habituais com histórico de pedidos.",
        },
        {
          t: "Gráfico de pedigree",
          d: "Análise de ancestrais em várias gerações e linhagens.",
        },
        {
          t: "Painel de vendas",
          d: "Quais potros foram vendidos, reservados ou ainda estão disponíveis.",
        },
      ],
    },
    beforeAfter: {
      title: "De Excel e agenda para o EquiSight de criação.",
      lead: "De forma concreta: é assim que a sua temporada de reprodução muda.",
      rows: [
        {
          before: "Ciclo em anotações avulsas",
          after: "Registro diário com previsão",
        },
        {
          before: "Ecografias via WhatsApp para o inseminador",
          after: "Dossiê compartilhado com fotos",
        },
        {
          before: "Data de gestação na agenda",
          after: "Lembretes automáticos de marcos",
        },
        {
          before: "Passaporte do potro na gaveta",
          after: "Documento vinculado ao perfil do potro",
        },
        {
          before: "Pedigree em papel",
          after: "Pedigree clicável até 4-5 gerações",
        },
        {
          before: "Anúncio de venda no Marktplaats",
          after: "Pipeline de vendas com lista de interessados",
        },
      ],
    },
    helper: {
      title: "Qual software de criação é ideal para você?",
      lead: "5 perguntas para verificar se você precisa de um app completo de criação ou se uma ferramenta para hobbyistas é suficiente.",
      questions: [
        {
          id: "mares",
          q: "Quantas éguas reprodutoras você gerencia?",
          options: [
            {
              label: "1 égua",
              score: 1,
            },
            {
              label: "2-5 éguas",
              score: 2,
            },
            {
              label: "Mais de 5 éguas",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Com que frequência você cria por ano?",
          options: [
            {
              label: "Ocasionalmente (a cada poucos anos)",
              score: 0,
            },
            {
              label: "1-2 coberturas por ano",
              score: 2,
            },
            {
              label: "3 ou mais coberturas por ano",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Como você insemina/cobre?",
          options: [
            {
              label: "Cobertura natural",
              score: 1,
            },
            {
              label: "IA com sêmen fresco/resfriado",
              score: 2,
            },
            {
              label: "TE ou sêmen congelado",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Você colabora com veterinário/inseminador?",
          options: [
            {
              label: "Uma pessoa fixa",
              score: 1,
            },
            {
              label: "Várias clínicas",
              score: 2,
            },
            {
              label: "Rede internacional",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "O que você registra atualmente?",
          options: [
            {
              label: "Excel ou papel",
              score: 1,
            },
            {
              label: "App genérico de gestão equestre",
              score: 2,
            },
            {
              label: "Nada estruturado",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uma ferramenta para hobbyistas ou Excel é suficiente — mas o EquiSight continua sendo útil.",
          body: "Para 1 égua com cobertura natural a cada poucos anos, um módulo de criação completo é excessivo. O EquiSight começa gratuitamente e você ativa o módulo de criação apenas no ano em que cobre — sem obrigação de upgrade.",
          cta: "Começar gratuitamente",
        },
        mid: {
          title: "O EquiSight de criação é a ferramenta certa.",
          body: "Você tem várias éguas ou vários métodos de reprodução — apps equestres genéricos não foram feitos para isso. O EquiSight combina criação e cuidados gerais, para que você não precise alternar entre duas ferramentas.",
          cta: "Ver o módulo de criação",
        },
        high: {
          title: "O EquiSight foi criado para o seu haras.",
          body: "Várias éguas, TE ou sêmen congelado, equipe internacional — a maioria das ferramentas fica aquém aqui. O EquiSight cresce junto com o nível do haras sem acumular licenças extras.",
          cta: "Fale conosco sobre um plano para Haras",
        },
      },
    },
    faqTitle: "Perguntas frequentes sobre software de criação",
    faq: [
      {
        q: "Qual é o melhor software de criação de cavalos?",
        a: "Para 1 égua sem métodos reprodutivos complexos, muitas ferramentas são suficientes. A partir de 2-3 éguas, uso de IA ou TE, ou colaboração com veterinário e stud book, um módulo completo de criação torna-se essencial. O EquiSight combina criação e gestão equestre geral em um único app, para que você não precise alternar.",
      },
      {
        q: "Quais funcionalidades de criação eu realmente preciso?",
        a: "No mínimo: registro de ciclo, dados de inseminação/cobertura, marcos de controle de gestação e dossiê do potro. Opcional, mas poderoso: visualização de pedigree, histórico de escolha de garanhão, DNA/passaporte e pipeline de vendas.",
      },
      {
        q: "O EquiSight consegue prever o ciclo de uma égua?",
        a: "Sim. O EquiSight usa dados de ciclos anteriores para mostrar a ovulação prevista, para que você planeje a inseminação ou cobertura no momento certo — sem quebrar a cabeça todos os dias.",
      },
      {
        q: "O EquiSight também funciona para transferência de embrião?",
        a: "Sim. A égua doadora e a receptora recebem dossiês vinculados, calendário de TE e marcos compartilhados com a clínica. Assim você não perde nenhuma etapa no complexo fluxo de TE.",
      },
      {
        q: "Posso importar meus dados de criação existentes?",
        a: "Você pode inserir ciclos, coberturas e dados de potros manualmente ou em lote via CSV. Para haras ativos com dados de várias temporadas, ajudamos com uma migração pontual.",
      },
      {
        q: "Como compartilho o dossiê com meu veterinário ou inseminador?",
        a: "Cada pessoa recebe acesso com uma função: veterinário, inseminador, proprietário de garanhão ou funcionário do stud book. Cada um vê apenas as informações necessárias para sua função — sem precisar de acesso completo.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software para coudelaria: comparação completa e guia de escolha 2026",
      description: "Compare software para coudelarias em aulas, cavaleiros, cavalos e administração. Descubra qual aplicativo se adapta à sua coudelaria ou estábulo de pensão.",
      keywords: [
        "software para coudelaria",
        "aplicativo de gestão de estábulo",
        "software de administração de coudelaria",
        "planejamento de aulas coudelaria",
        "software para estábulo de pensão",
        "administração de cavaleiros",
        "administração de cavalos coudelaria",
      ],
    },
    hero: {
      eyebrow: "Guia de escolha · software para coudelaria",
      breadcrumbLabel: "Software para coudelaria",
      title: "Software para coudelaria: o guia completo de escolha para coudelarias e estábulos de pensão.",
      intro: "Planejamento de aulas, administração de cavaleiros, gestão de cavalos, faturamento e comunicação — um bom software para coudelaria reúne tudo isso. Compare as opções mais conhecidas e descubra qual se adapta ao seu estábulo ou coudelaria.",
      pills: [
        {
          icon: "Calendar",
          label: "Planejamento de aulas",
        },
        {
          icon: "Users",
          label: "Cavaleiros e clientes",
        },
        {
          icon: "Heart",
          label: "Cuidados com cavalos",
        },
        {
          icon: "CreditCard",
          label: "Faturamento",
        },
      ],
      ctas: [
        {
          label: "Solicite uma demonstração",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabela de comparação",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por que ferramentas dispersas tornam uma coudelaria lenta.",
      lead: "A maioria das coudelarias funciona com um conjunto fragmentado: planejamento de aulas num quadro branco, registro de cavaleiros no Excel, faturamento em outra ferramenta, cuidados com cavalos no WhatsApp e contato com proprietários via mensagens pessoais. Em uma semana movimentada, surgem reservas duplicadas, faturas esquecidas ou cavalos sem saber qual cavaleiro irão receber.",
      items: [
        "Quem está na aula agora com Jasmijn?",
        "Qual cavaleiro ainda não pagou por março?",
        "Qual cavalo não pode ser usado esta semana?",
        "Quem são os contatos de emergência dos alunos?",
        "O proprietário de Stardust já recebeu a fatura do ferrador?",
        "Qual cavalo está em qual baia?",
      ],
    },
    what: {
      title: "O que é software para coudelaria?",
      lead: "O software para coudelaria combina planejamento de aulas, administração de cavaleiros, gestão de cavalos, faturamento e comunicação em uma única ferramenta. Sem acrobacias no Excel ou confusão no WhatsApp, mas um só lugar onde a coudelaria funciona e proprietários/cavaleiros acompanham tudo.",
      targetGroupsTitle: "Para que tipo de empresa é indicado o software para coudelaria?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Coudelaria pequena (1-15 cavalos)",
          body: "Principalmente planejamento de aulas e pagamentos — administração sem dor de cabeça.",
        },
        {
          icon: "Users",
          title: "Coudelaria média (15-40 cavalos)",
          body: "Vários instrutores, planejamento de aulas + escala de cavalos + administração de cavaleiros.",
        },
        {
          icon: "ClipboardList",
          title: "Estábulo de equitação e pensão grande (40+)",
          body: "Operação completa incluindo faturamento, planejamento de alimentação e ferragem.",
        },
        {
          icon: "Heart",
          title: "Estábulo de pensão",
          body: "Portal do proprietário, instruções de cuidados individuais, agenda compartilhada.",
        },
        {
          icon: "Target",
          title: "Estábulo de treinamento de salto",
          body: "Planejamento de competições, treinamento por cavalo, contato com clientes.",
        },
        {
          icon: "FileText",
          title: "Empresários hípicos",
          body: "Mix de aulas + pensão + clínica + comércio — tudo a partir de um único sistema.",
        },
      ],
    },
    criteria: {
      title: "O que um bom software para coudelaria deve atender?",
      lead: "Um aplicativo bonito não significa nada se os seus funcionários não quiserem usá-lo. Cinco critérios práticos que fazem a diferença entre sucesso e frustração.",
      items: [
        {
          icon: "Calendar",
          title: "Planejamento de aulas em vários níveis",
          body: "Iniciante/avançado, adestramento/salto, vínculos cavalo-cavaleiro e agendas de instrutores — tudo visível lado a lado.",
        },
        {
          icon: "Users",
          title: "Administração de cavaleiros",
          body: "Perfis, nível, assinatura, cartão de aulas e vínculos familiares para cavaleiros jovens.",
        },
        {
          icon: "Heart",
          title: "Escala de cavalos",
          body: "Qual cavalo é usado com que frequência, com períodos de descanso, lesão e recuperação.",
        },
        {
          icon: "CreditCard",
          title: "Faturamento e assinaturas",
          body: "Assinaturas mensais, cartões de aulas, aulas avulsas e débito automático.",
        },
        {
          icon: "Share2",
          title: "Portal do proprietário (estábulo de pensão)",
          body: "Proprietários veem seu cavalo no próprio aplicativo — agenda, custos, ferragem e anotações sem precisar ligar.",
        },
        {
          icon: "Bell",
          title: "Comunicação e lembretes",
          body: "Lembretes automáticos de aulas, avisos de pagamento, anúncios de ferragem — sem precisar enviar mensagens.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs outros softwares para coudelaria.",
      lead: "Muitas ferramentas para coudelaria são fortes em planejamento de aulas ou faturamento, mas raramente em cuidados com cavalos e comunicação com proprietários ao mesmo tempo. Colocamos tudo honestamente lado a lado.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Início gratuito / período de teste",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planejamento de aulas",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Vários instrutores",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administração de cavaleiros",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Escala de cavalos",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cuidados com cavalos (vacinação/ferragem)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cartão de aulas / assinatura",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pagamentos online",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Faturamento automático",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal do proprietário (pensão)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integração ferrador/veterinário",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lembretes por WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planejamento de competições",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adequado para estábulo de pensão",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparação baseada em funcionalidades publicamente disponíveis em janeiro de 2026. O Stalmanager é forte em administração; o EquiSight se destaca no fluxo de estábulo de pensão + cuidados com cavalos + portal do proprietário.",
    },
    why: {
      title: "Por que o EquiSight é diferente para coudelarias e estábulos de pensão.",
      lead: "O EquiSight vai além de um planejador de aulas. Enxergamos uma coudelaria como uma operação completa: cavalos, pessoas, comunicação e finanças — todos interdependentes.",
      points: [
        {
          icon: "Heart",
          title: "O cavalo no centro, não a agenda",
          body: "Cada cavalo tem seu próprio dossiê. Participação em aulas, saúde, ferragem e competições em uma única linha do tempo — não em 3 ferramentas separadas.",
        },
        {
          icon: "Share2",
          title: "Proprietários acompanham sem precisar ligar",
          body: "Proprietários do estábulo de pensão têm sua própria visualização: custos, planejamento, fotos e anotações — economiza de 5 a 10 telefonemas por semana.",
        },
        {
          icon: "Bell",
          title: "Comunicação automática",
          body: "Lembrete de aula, lembrete de vacinação, fatura — automático, via aplicativo/e-mail/SMS. Chega de broadcasts pelo WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Para o estábulo de pensão",
      title: "O que um estábulo de pensão ganha com o EquiSight.",
      lead: "Os estábulos de pensão têm desafios únicos que softwares comuns para coudelaria não resolvem.",
      cards: [
        {
          t: "Portal do proprietário",
          d: "Cada proprietário vê apenas seu(s) cavalo(s), agenda e custos.",
        },
        {
          t: "Instruções de cuidado por cavalo",
          d: "Alimentação, volumoso, suplementos, escala de mantas — visíveis para o estábulo.",
        },
        {
          t: "Agenda compartilhada",
          d: "Ferrador, veterinário e visitas dos proprietários em uma única visualização.",
        },
        {
          t: "Custos de consumo por cavalo",
          d: "Cama, alimentação e ração concentrada repassados por proprietário.",
        },
        {
          t: "Contatos de emergência do cavalo",
          d: "Proprietário + veterinário + ferrador sempre acessíveis para o estábulo.",
        },
        {
          t: "Gestão de pastagem",
          d: "Quais cavalos vão para pasto, estão em descanso ou em reabilitação?",
        },
      ],
    },
    beforeAfter: {
      title: "Do quadro branco + Excel para o EquiSight.",
      lead: "Na prática: é assim que uma semana de trabalho na coudelaria muda.",
      rows: [
        {
          before: "Quadro branco com o planejamento de aulas",
          after: "Planejamento ao vivo por instrutor",
        },
        {
          before: "Excel com cavaleiros + anotações de aulas",
          after: "CRM de clientes com histórico de aulas",
        },
        {
          before: "WhatsApp para proprietários",
          after: "Portal de proprietários para o seu cavalo",
        },
        {
          before: "Débito automático mensal manual",
          after: "Faturamento automático + iDEAL",
        },
        {
          before: "Cuidados com cavalos num quadro de avisos",
          after: "Instruções de cuidado por cavalo, compartilhadas",
        },
        {
          before: "Agendamento verbal com o ferrador",
          after: "Planejamento de ferragem com confirmações",
        },
      ],
    },
    helper: {
      title: "Qual software para coudelaria é ideal para você?",
      lead: "5 perguntas para saber se o EquiSight é a plataforma certa para a sua coudelaria ou estábulo de pensão.",
      questions: [
        {
          id: "size",
          q: "Quantos cavalos você tem no seu negócio?",
          options: [
            {
              label: "Menos de 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Mais de 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Qual é a sua atividade principal?",
          options: [
            {
              label: "Principalmente dar aulas",
              score: 1,
            },
            {
              label: "Estábulo de pensão (cavalos em pensão)",
              score: 3,
            },
            {
              label: "Mix de aulas + pensão",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Com quantos instrutores você trabalha?",
          options: [
            {
              label: "Somente eu",
              score: 1,
            },
            {
              label: "2-3 instrutores",
              score: 2,
            },
            {
              label: "4 ou mais",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Como você gerencia seu faturamento atualmente?",
          options: [
            {
              label: "Manualmente (Word/Excel)",
              score: 3,
            },
            {
              label: "Programa de contabilidade separado",
              score: 2,
            },
            {
              label: "Integrado na ferramenta de aulas",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Como você se comunica com os proprietários?",
          options: [
            {
              label: "Pessoalmente / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Portal do proprietário na ferramenta",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uma ferramenta simples ou Excel pode servir por ora — mas o EquiSight acompanha o seu crescimento.",
          body: "Para uma pequena escola de equitação com um instrutor e pouca pensão, um pacote completo não é imediatamente necessário. O EquiSight começa gratuitamente e cresce junto com a sua coudelaria — sem dores de migração daqui a alguns anos.",
          cta: "Comece gratuitamente",
        },
        mid: {
          title: "O EquiSight é uma evolução natural para a sua coudelaria.",
          body: "Vários instrutores, um mix de aulas e pensão, ou faturamento que hoje está desconectado — o EquiSight reúne tudo em um único fluxo de trabalho. Especialmente o portal do proprietário economiza muito na comunicação ad hoc.",
          cta: "Solicite uma demonstração",
        },
        high: {
          title: "O EquiSight foi criado para a sua escala.",
          body: "Estábulo de pensão + aulas + vários instrutores é exatamente onde o EquiSight se diferencia das ferramentas tradicionais para coudelaria. O portal do proprietário e a integração de cuidados com cavalos economizam horas semanais de administração e comunicação.",
          cta: "Agende uma demonstração para o seu estábulo",
        },
      },
    },
    faqTitle: "Perguntas frequentes sobre software para coudelaria",
    faq: [
      {
        q: "Qual é o melhor software para coudelaria?",
        a: "Para o planejamento puro de aulas, existem várias boas opções. A partir do momento em que você precisa de um estábulo de pensão, vários instrutores ou rastreamento de cuidados com cavalos, o EquiSight torna-se a solução completa — sem malabarismo com ferramentas, tudo em um só lugar.",
      },
      {
        q: "Posso importar clientes e aulas existentes?",
        a: "Sim. Dados de clientes e grades de aulas podem ser importados via CSV. Ajudamos coudelarias ativas com uma migração única para que você não precise inserir 200 cavaleiros manualmente.",
      },
      {
        q: "Funciona também para um estábulo de pensão sem aulas?",
        a: "Sim. O modo de estábulo de pensão desativa as aulas e foca no portal do proprietário, alimentação/cuidados, planejamento de ferragem e repasse de custos por cavalo.",
      },
      {
        q: "Os cavaleiros podem se inscrever e pagar por conta própria?",
        a: "Sim. Os cavaleiros podem, através de uma conta própria, ver quais aulas estão disponíveis, inscrever-se, pagar mensalidades com iDEAL e adquirir cartões de aulas.",
      },
      {
        q: "Como fica a privacidade dos dados de cavalos e proprietários?",
        a: "Cada pessoa tem um papel (proprietário, cavaleiro, instrutor, funcionário). Por papel, você vê apenas o que precisa. Proprietários veem apenas o seu cavalo; cavaleiros, apenas as suas próprias aulas.",
      },
      {
        q: "O EquiSight pode integrar com o meu software de contabilidade?",
        a: "Sim, integrações com Exact, Moneybird e e-Boekhouden estão disponíveis. As faturas fluem automaticamente para a sua contabilidade.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "App de treinador para cavalos: comparação e guia de escolha para coaches 2026",
      description: "Compare apps de treinador para cavalo e amazona: diário de treino, vídeo, objetivos, análise de protocolo e gestão de clientes. Encontre a ferramenta certa para coaches.",
      keywords: [
        "app de treinador para cavalos",
        "app de instrutor",
        "app de treino de cavalos",
        "app de coaching para amazona",
        "diário de treino de cavalos",
        "analisar protocolo de dressage",
        "software para treinador de cavalos",
      ],
    },
    hero: {
      eyebrow: "Guia de escolha · software de treinador",
      breadcrumbLabel: "App de treinador",
      title: "App de treinador para cavalos: guia completo para instrutores e coaches.",
      intro: "Um treinador ou instrutor faz malabarismos com combinações, aulas, vídeos, objetivos e competições. Compare as melhores apps de treinador para pessoas do mundo equestre e escolha a plataforma que também em 2026 acompanha o crescimento do seu coaching.",
      pills: [
        {
          icon: "Target",
          label: "Objetivos e planeamento",
        },
        {
          icon: "Video",
          label: "Análise de vídeo",
        },
        {
          icon: "TrendingUp",
          label: "Progresso",
        },
        {
          icon: "Users",
          label: "Clientes/combinações",
        },
      ],
      ctas: [
        {
          label: "Começa grátis como treinador",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabela de comparação",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por que o coaching via WhatsApp atrapalha os treinadores.",
      lead: "A maioria dos treinadores trabalha com ferramentas separadas: WhatsApp para comunicação, um caderno de notas para as aulas, YouTube ou WeTransfer para vídeos e Excel para resultados de competições. Com 5 amazonas funciona. Com 20 amazonas, as informações perdem-se, os objetivos são esquecidos e perde-se o controlo do progresso individual.",
      items: [
        "Qual é o objetivo da Anouk para esta temporada?",
        "Que vídeo enviei ao Bram no mês passado?",
        "A Lara já viu a análise do protocolo da sua última competição?",
        "Qual combinação treina quantas vezes por semana?",
        "O proprietário do Stardust leu as minhas instruções de treino?",
        "Quando foi a última vez que dei feedback sobre o impulso irregular?",
      ],
    },
    what: {
      title: "O que é uma app de treinador para cavalo e amazona?",
      lead: "Uma app de treinador combina um CRM de coaching (combinações, aulas, objetivos), um diário de treino por cavalo, feedback em vídeo, planeamento de competições e análise de protocolo. Sem mais WhatsApp/YouTube/Excel separados, mas uma única plataforma onde treinador e amazona trabalham juntos.",
      targetGroupsTitle: "Para que tipo de treinador é indicado?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instrutor de dressage",
          body: "Digitalizar protocolos, associar comentários do juiz a objetivos de treino, acompanhar o progresso.",
        },
        {
          icon: "Activity",
          title: "Treinador de saltos",
          body: "Planeamento de percurso, feedback por volta, gestão de alturas por cavalo.",
        },
        {
          icon: "Award",
          title: "Coach de eventing",
          body: "Três disciplinas, três planeamentos — todos visíveis lado a lado.",
        },
        {
          icon: "TrendingUp",
          title: "Coach de performance (desporto)",
          body: "Monitorização EPI, competições, objetivos — para desportistas de alto nível e as suas equipas.",
        },
        {
          icon: "Users",
          title: "Instrutor de escola de equitação",
          body: "Aulas em grupo + coaching individual numa só app.",
        },
        {
          icon: "Heart",
          title: "Coach recreativo",
          body: "Terapia equestre, iniciantes, proprietários com um único cavalo.",
        },
      ],
    },
    criteria: {
      title: "O que deve ter uma boa app de treinador?",
      lead: "Treinar é trabalho humano, mas a ferramenta certa torna-te 30-50% mais eficiente e ajuda as amazonas a melhorarem também entre as aulas.",
      items: [
        {
          icon: "Users",
          title: "Gestão de combinações",
          body: "Cavalo + amazona como uma unidade, com nível, objetivos, progresso e histórico.",
        },
        {
          icon: "ClipboardList",
          title: "Notas de aula e objetivos",
          body: "Por aula, uma nota com pontos de foco, ligada a objetivos de longo prazo.",
        },
        {
          icon: "Video",
          title: "Feedback em vídeo",
          body: "Carrega vídeo, marca momentos, adiciona feedback falado ou escrito.",
        },
        {
          icon: "Target",
          title: "Análise de competição e protocolo",
          body: "Digitaliza protocolos (KNHS/FEI), vê pontuações por elemento, comentários do juiz e tendências.",
        },
        {
          icon: "Calendar",
          title: "Planeamento e cartões de aula",
          body: "Agenda, pagamentos, assinaturas e lembretes automáticos.",
        },
        {
          icon: "Share2",
          title: "Comunicação com a amazona",
          body: "A amazona vê a sua própria página com aulas, vídeos, objetivos e feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs outras apps de treinador.",
      lead: "Algumas ferramentas de treinador focam-se em substituir o WhatsApp, outras na análise de protocolos. EquiSight combina ambas com um verdadeiro dossier do cavalo — para que a amazona também melhore entre as aulas.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Começar grátis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Gestão de combinações",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Notas de aula e feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Objetivos a longo prazo",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Upload de vídeo + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Digitalizar protocolo KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Índice de Performance)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Calendário de competições",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal da amazona",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Cartão de aulas / assinatura",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pagamentos online",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Dossier integrado do cavalo",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ferrador/veterinário visível",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Para instrutor E amazona",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Múltiplos cavalos por amazona",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparação baseada em funcionalidades publicamente disponíveis em janeiro de 2026. EquiSight é único na análise de protocolo + EPI e combina isso com a gestão geral do cavalo.",
    },
    why: {
      title: "Por que EquiSight oferece uma experiência diferente para treinadores.",
      lead: "A maioria das ferramentas de treinador termina onde a aula acaba. EquiSight continua — no dossier do cavalo, na análise de competições, na colaboração com o veterinário e o proprietário.",
      points: [
        {
          icon: "TrendingUp",
          title: "Digitalização do protocolo → objetivo de treino",
          body: "Digitaliza um protocolo KNHS e vê diretamente quais os elementos que precisam de atenção. Os objetivos surgem automaticamente.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach reforça o teu olhar",
          body: "Dados de várias aulas, competições e protocolos revelam padrões que não consegues reter na memória.",
        },
        {
          icon: "Share2",
          title: "Integrado com o cavalo",
          body: "O treinador vê o histórico de vacinações, ferrador e lesões do cavalo — sem planear treinos durante a recuperação.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Para dressage e saltos",
      title: "O que contém um dossier de coaching no EquiSight.",
      lead: "Por combinação tens uma stream de coaching que mantém tudo junto — sem mais perder coisas no WhatsApp.",
      items: [
        "Notas de aula com pontos de foco por sessão",
        "Objetivos a longo prazo + marcos",
        "Upload de vídeo com comentários por código de tempo",
        "Digitalização de protocolo KNHS/FEI com pontuações",
        "Comentários do juiz associados ao treino",
        "Resultados de competições e tendência EPI",
        "Contacto com o cliente e histórico de aulas",
        "Cartão de aulas / assinatura / faturas",
        "Gráfico de progresso por disciplina",
        "Acesso partilhado com o proprietário do cavalo",
      ],
      ctaLabel: "Ver o módulo de treinador",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "De WhatsApp + YouTube para EquiSight Trainer.",
      lead: "Concretamente: é assim que o teu fluxo de trabalho de coaching muda.",
      rows: [
        {
          before: "WhatsApp com links de vídeo soltos",
          after: "Vídeo com feedback por código de tempo no dossier",
        },
        {
          before: "Caderno de notas por amazona",
          after: "Registo de coaching com objetivos e histórico",
        },
        {
          before: "Excel com pontuações de competições",
          after: "Gráfico EPI + análise de protocolo",
        },
        {
          before: "Objetivos verbais",
          after: "Marcos com indicador de progresso",
        },
        {
          before: "Ferramenta de faturação separada",
          after: "Aulas + iDEAL + assinatura na app",
        },
        {
          before: "Email ao proprietário sobre o progresso",
          after: "Proprietário acompanha na sua própria vista",
        },
      ],
    },
    helper: {
      title: "Qual app de treinador é a certa para ti?",
      lead: "5 perguntas para perceber se uma ferramenta de coaching especializada acrescenta valor à tua prática.",
      questions: [
        {
          id: "clients",
          q: "Quantas combinações ativas estás a treinar?",
          options: [
            {
              label: "Menos de 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Mais de 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Qual é a tua disciplina principal?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Saltos",
              score: 2,
            },
            {
              label: "Recreativo / diverso",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Usas vídeo no coaching?",
          options: [
            {
              label: "Raramente",
              score: 0,
            },
            {
              label: "Às vezes (manualmente)",
              score: 2,
            },
            {
              label: "Frequentemente — de forma estruturada",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Treinas amazonas de competição?",
          options: [
            {
              label: "Não, recreativo",
              score: 0,
            },
            {
              label: "Às vezes em competições",
              score: 2,
            },
            {
              label: "Muitas — cartões de partida centrais",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Queres medir o teu coaching?",
          options: [
            {
              label: "Não, a intuição é suficiente",
              score: 0,
            },
            {
              label: "Gostava, mas não tenho tempo",
              score: 2,
            },
            {
              label: "Sim — coaching baseado em dados",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uma ferramenta simples ou mesmo o WhatsApp é suficiente — por agora.",
          body: "Para menos de 5 amazonas sem muito vídeo ou competições, uma app de coaching é excessivo. EquiSight começa grátis, por isso podes experimentar quando a tua prática crescer.",
          cta: "Começa grátis",
        },
        mid: {
          title: "EquiSight Trainer torna-te estruturalmente mais eficiente.",
          body: "Com 5-15 combinações, perdes horas por mês no WhatsApp e em vídeos soltos. EquiSight reúne tudo, digitaliza protocolos automaticamente e garante que as amazonas possam sempre rever o seu feedback.",
          cta: "Experimenta o módulo Trainer",
        },
        high: {
          title: "EquiSight foi construído para a tua escala de coaching.",
          body: "Muitas amazonas, vídeo, competições e coaching baseado em dados: é exatamente aqui que EquiSight se distingue. EPI + digitalização de protocolos + dossier do cavalo dá-te uma vantagem que os concorrentes não têm.",
          cta: "Marca uma demonstração para a tua prática de coaching",
        },
      },
    },
    faqTitle: "Perguntas frequentes sobre apps de treinador",
    faq: [
      {
        q: "Qual é a melhor app de treinador para cavalo e amazona?",
        a: "Para comunicação pura, muitas ferramentas são suficientes (até o WhatsApp). Para objetivos, análise de vídeo, digitalização de protocolos, acompanhamento de competições e gestão de clientes numa só ferramenta, EquiSight é a solução mais completa — especialmente porque também acompanha o próprio cavalo, não apenas a combinação.",
      },
      {
        q: "O EquiSight consegue ler protocolos de competição automaticamente?",
        a: "Sim. Carrega um protocolo KNHS ou FEI e o EquiSight extrai as pontuações por elemento, os comentários do júri e associa-os à combinação. As tendências são visíveis ao longo de várias competições.",
      },
      {
        q: "O que é o EPI (Equestrian Performance Index)?",
        a: "O EPI é uma pontuação do EquiSight que converte vários resultados de competições num índice de performance comparável. Assim, vês o progresso real através de diferentes categorias e júris.",
      },
      {
        q: "As amazonas podem reservar e pagar as minhas aulas por conta própria?",
        a: "Sim. As amazonas fazem login, veem os horários disponíveis, compram cartões de aulas e pagam via iDEAL. Tu decides o que queres disponibilizar.",
      },
      {
        q: "Funciona também para um instrutor que trabalha numa escola de equitação?",
        a: "Sim. Podes trabalhar como treinador freelance com os teus próprios clientes sem precisar de associar uma conta de escola de equitação. Os clientes pagam-te diretamente.",
      },
      {
        q: "Posso migrar vídeos e notas existentes?",
        a: "Os vídeos podem ser carregados por combinação ou através de uma ferramenta de upload em lote. As notas são importadas via CSV. Ajudamos os treinadores ativos com uma migração única.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guias e ferramentas de escolha para software de gestão equestre | EquiSight",
      description: "Todos os guias EquiSight num só lugar: gestão equestre, criação, picadeiro e comparações de software para treinadores, mais ferramentas de escolha para 2026.",
      keywords: [
        "guias de software equestre",
        "ferramenta de escolha para gestão equestre",
        "comparar software de criação equestre",
        "guia de software para picadeiro",
        "comparação de apps para treinadores",
      ],
    },
    hub: {
      eyebrow: "Hub · guias",
      breadcrumbLabel: "Guias",
      title: "Quatro guias completos para escolher o software equestre certo.",
      intro: "Uma ferramenta de escolha aprofundada para cada perfil: tabelas de comparação, critérios, exemplos e quiz interativo. Clique no guia que corresponde à sua situação, ou explore primeiro os artigos aprofundados em cada cluster.",
      stats: {
        guides: "4 ferramentas de escolha",
        articles: "15 artigos aprofundados",
        fair: "Comparação imparcial",
      },
      readMoreCta: "Ler o guia completo",
      relatedHeading: "Artigos aprofundados",
      articlesCountSingular: "{{count}} artigo aprofundado",
      articlesCountPlural: "{{count}} artigos aprofundados",
      articlesCountAria: "Número de artigos do cluster",
      lastUpdatedPrefix: "Atualizado",
      lastUpdatedAria: "Data da última atualização deste cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Ferramenta de escolha para app de gestão equestre",
        blurb: "Compare as apps de gestão equestre mais conhecidas e descubra qual se adequa a proprietário, estábulo ou criação. Inclui tabela de comparação imparcial e ferramenta de escolha com 5 perguntas.",
        audience: "Para proprietários, responsáveis de estábulos e todos os amantes de cavalos que procuram uma visão geral.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Comparação de software de criação equestre",
        blurb: "Do ciclo da égua ao desenvolvimento do poldro: veja qual software de criação realmente funciona para o número de éguas, método de criação e exigências do stud book.",
        audience: "Para criadores (amadores e profissionais), haras e proprietários de garanhões.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Ferramenta de escolha para software de picadeiro",
        blurb: "Planeamento de aulas, administração de cavaleiros, portal de proprietários e faturação — numa única ferramenta. Compare as opções para picadeiros e estábulos de pensão em 2026.",
        audience: "Para picadeiros, estábulos de pensão e centros hípicos.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Ferramenta de escolha para app de treinadores",
        blurb: "CRM de coaching, feedback em vídeo, análise de protocolos KNHS e objetivos por combinação. Qual app de treinador se adapta à sua prática de coaching?",
        audience: "Para instrutores, treinadores e coaches.",
      },
    ],
    closing: {
      eyebrow: "Porquê estes guias",
      title: "Comparação honesta, não apenas preços.",
      body1: "Muitas \"páginas de comparação\" são publicidade disfarçada. Os nossos guias colocam funcionalidades, público-alvo e concorrentes lado a lado como uma fonte de conhecimento independente faria. O EquiSight surge naturalmente como a solução completa, mas também poderá ler honestamente onde outras apps são mais fortes.",
      body2: "Os artigos aprofundados em cada guia respondem às questões concretas que surgem após a escolha: \"Quando fazer o primeiro eco após inseminação\", \"Como automatizar a faturação do picadeiro\", \"Como analisar um protocolo de competição\". Sem marketing vazio, apenas prática.",
    },
    hubName: "Guias EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Por que isso é um problema",
      basics: "Básico",
      criteria: "O que torna isso bom?",
      comparison: "Comparação honesta",
      why: "A diferença",
      beforeAfter: "Da fragmentação à clareza",
      helper: "5 perguntas",
    },
    table: {
      feature: "Funcionalidade",
      today: "Hoje",
      withEquisight: "Com o EquiSight",
    },
    helper: {
      questionLabel: "Pergunta {{current}} de {{total}}",
      answerPrompt: "Responda à {{count}} pergunta restante para ver uma recomendação.",
      answerPromptPlural: "Responda às {{count}} perguntas restantes para ver uma recomendação.",
      resultEyebrow: "O seu resultado",
    },
    targetGroupsFallback: "Para quem é isto?",
    faqTitleFallback: "Perguntas frequentes",
  },
};

export default CORNERSTONES;
